import api from './api';
import type { Dificultad } from '../types/reactivos.types';

const API_URL = '/api/dificultades';

export const dificultadService = {
  /**
   * Obtener todas las dificultades
   */
  listar: async (): Promise<Dificultad[]> => {
    const response = await api.get<Dificultad[]>(API_URL);
    return response.data;
  },

  /**
   * Obtener todas las dificultades (alias para listar)
   */
  getDificultades: async (): Promise<Dificultad[]> => {
    const response = await api.get<Dificultad[]>(API_URL);
    return response.data;
  }
};

export default dificultadService;
